module.exports = __webpack_public_path__ + "static/media/transparency_01.dfcdba48.png";